<template>
<div v-if="stepper.steps && stepper.steps.length > 0" class="nav-buttons">

    <div class="stepper-button-left">
        <vm-button rounded :text="currentStep().pText" :disabled="currentStep().pDisabled" @clicked="handleStepClick(stepper.step - 2)" />
    </div>
    <div class="stepper-button-right">
        <vm-button rounded :text="currentStep().nText" :disabled="currentStep().nDisabled" @clicked="handleStepClick(stepper.step)" />
    </div>

</div>
</template>
<script>

export default {
name: 'NavButtons',
props: {
    stepper: {
        type: Object,
        default: null
    }
},
data() {
    return {
        
    }
},
watch: {
    stepper: {
        deep: true,
        handler(val) {
            //console.log('HS: data changed', val);
        }
    },
},
methods: {
    handleStepClick(index) {
        if (index < 0) return;
        if (index >= this.stepper.steps.length) return this.$emit('submit', true);
        this.$emit('step', this.stepper.steps[index].key);
    },
    currentStep() {
        return this.stepper.steps[this.stepper.step - 1];
    }
},
}
</script>
<style scoped>

.nav-buttons {
    position: fixed;
    bottom: 0px; left: 0px;
    width: 100%;
    height: 60px;
    background-color: #004976;
    z-index: 2;
}

@media only screen and (min-width: 1000px) {
    .nav-buttons {
        display: none;
    }
}

.stepper-button-left {
    position: absolute;
    top: 12px; left: 20px;
}
.stepper-button-right {
    position: absolute;
    top: 12px; right: 20px;
}

</style>
